import { LoadingButton } from "@mui/lab";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { requestEmailChange } from "api/auth";
import useAPICall from "hooks/useAPICall";
import { useState } from "react";
// import useSnackbarCustom from "hooks/useSnackbarCustom";
import { useForm } from "react-hook-form";
import { FormProvider, RHFTextField } from "components/hook-form";

type Props = {
  open: boolean;
  onClose: () => void;
};

type FormProps = {
  new_email: string;
};

export const EmailChangeModal = ({ open, onClose }: Props) => {
  const [sent, setSent] = useState(false);
  // const { success } = useSnackbarCustom();

  const form = useForm<FormProps>({
    defaultValues: {
      new_email: "",
    },
  });

  const { callAPI, sending, makeSendData, generalErrorMessage, errorMode } = useAPICall({
    apiMethod: requestEmailChange,
    failedMessage: () => "送信に失敗しました",
    onSuccess: () => {
      setSent(true);
      form.reset();
    },
    form,
  });

  const handleUpdate = async (data: FormProps) => {
    await callAPI(
      makeSendData({
        new_email: data.new_email,
      })
    );
  };

  const handleClose = () => {
    form.reset();
    setSent(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      {!sent ? (
        <FormProvider methods={form} onSubmit={form.handleSubmit(handleUpdate)}>
          <DialogTitle>メールアドレス変更</DialogTitle>
          <DialogContent>
            {errorMode === "server" && generalErrorMessage && (
              <div style={{ color: "red", marginBottom: "16px" }}>{generalErrorMessage}</div>
            )}
            <RHFTextField
              name="new_email"
              autoFocus
              margin="dense"
              label="新しいメールアドレス"
              fullWidth
              variant="outlined"
              disabled={sending}
              // type="email"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} disabled={sending}>
              キャンセル
            </Button>
            <LoadingButton type="submit" variant="contained" loading={sending}>
              送信
            </LoadingButton>
          </DialogActions>
        </FormProvider>
      ) : (
        <>
          <DialogTitle>メールアドレス変更</DialogTitle>
          <DialogContent>
            <div style={{ padding: "16px 0" }}>
              確認メールを送信しました。
              <br />
              メール内のリンクをクリックして変更を完了してください。
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="contained">
              閉じる
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
